module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/ico-ticket.a950426e.png";